// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class Coaching_Experience extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "Coaching_Experience";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      traineeCoachId: null,
      relationship: null,
      resourceAvailability: null,
      managerSupport: null,
      createdAt: null,
      updatedAt: null
    };
  }
}
const servicePath = "coaching-experience";
const servicePlugin = makeServicePlugin({
  Model: Coaching_Experience,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
